import React from "react";
import {Container, Grid} from "@material-ui/core";
import Page from "../../components/Page";
import ProductTable from "./ProductTable";
import CreateProductView from "./CreateProductView";
import {HasRole} from "../../common/Util";
import {RoleIdEnum} from "../../generated/graphql";

export default () => {
    return (
        <Page title={"customer page"}>
            <Container maxWidth={false} style={{ padding: "30px"}}>
                <Grid container spacing={2}>
                    <HasRole roles={[RoleIdEnum.Admin, RoleIdEnum.Finance]}>
                        <CreateProductView/>
                    </HasRole>
                    <ProductTable/>
                </Grid>
            </Container>
        </Page>
    )
}